import Vue from 'vue'
import Vuex from 'vuex'
import router from './router'
var firebase = require('firebase/app')
import db from './main'
import storage from './main'
import auth from './main'
import moment from 'moment'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    products: {},
    gallery: [],
    urlTemporal:'', file: null,
    usuario: null,
    procutsExter: {},
    procutsExternal: [],
    procutsSingle: {},
    procutsSingles: [], rating: 0
  },
  mutations: {
    pushGallery(state, e) {
      state.gallery = e
    },
    sendRating(state, payload){
      state.rating = payload
    },
    setProducts(state, payload) {
      state.products = payload
    },
    sendPreview(state, payload) {
      state.urlTemporal = payload
    },
    setProduct(state, file) {
      state.file = file
    },
    setUsuario(state, payload) {
      state.usuario = payload; 
    },
    nuevosPProducts(state, payload){
      state.procutsExternal = payload
    },
    nuevosProducts(state, payload){
      state.procutsSingle = payload
    },
    deletePro(state, id){
      state.procutsExternal = state.procutsExternal.filter( doc => {
        return doc.id != id
      } )
    }
  },
  actions: {
    loadGallery({commit}){

      const gallery = [] 

      db.collection('gallery').get()
      .then(snapshot =>{
        snapshot.forEach(res =>{
          gallery.push(res.data())
        })
        commit('pushGallery', gallery)
      })
    },
    getProductsList({commit}){
      const procutsExternal = [] 
      db.collection('products').get()
      .then(snapshot => {
        snapshot.forEach( doc => {
          let procutsExter = doc.data();
          procutsExter.id = doc.id
          procutsExter.name = doc.data().name
          procutsExter.description = doc.data().description
          procutsExter.avalible = doc.data().avalible
          procutsExter.price = doc.data().price
          procutsExter.image = doc.data().image
          procutsExter.rating = doc.data().rating
          procutsExternal.push(procutsExter) 
        })
        commit('nuevosPProducts', procutsExternal)
      })
    },
    deleteProduct({commit, dispatch}, id){
      const usuario = firebase.auth().currentUser
          db.collection('products').doc(id).delete()
          .then(()=>{
            //console.log('Post fue eliminado');
            commit('deletePro',id)
          })
    },
    loginUser({commit}, payload){
      
      firebase.auth().signInWithEmailAndPassword(payload.email, payload.password)
      .then(res=>{
        console.log(res.user)
        db.collection('usuarios').doc(res.user.uid).get(res.user.uid)
        .then(snapshot => {
          snapshot.forEach(doc =>{
            commit('setUsuario', 
            {
              email:         doc.data().email, 
              uid:           doc.data().uid, 
              name:          doc.data().name,
            })
          })
          router.push({name: 'cpanel'})
        })
      }).catch(e=>{
        console.log(e.message)
      })
    },
    detectarUsuario({commit}){

      const usuario = firebase.auth().currentUser

      db.collection('usuarios').doc(usuario.uid).get().then(res => {
        //console.log(res.data())
        commit('setUsuario', res.data())
    }).catch(() => {
      commit('setUsuario', null)
    })      
    },
    cerrarSesion({commit}){
      commit('setUsuario', null);
      firebase.auth().signOut();
      router.push({name: 'home'})
    },
    getProductsFirebase({commit}) {
      const procutsExternal = [] 
      db.collection('products').orderBy("avalible", "desc").limit(3).get()
      .then(snapshot => {
        snapshot.forEach( doc => {
          let procutsExter = doc.data();
          procutsExter.id = doc.id
          procutsExter.rating = doc.data().rating
          procutsExter.name = doc.data().name
          procutsExter.description = doc.data().description
          procutsExter.avalible = doc.data().avalible
          procutsExter.price = doc.data().price
          procutsExter.image = doc.data().image
          procutsExternal.push(procutsExter) 
        })
        commit('nuevosPProducts', procutsExternal)
      })
    },
    getProductSingle({commit}, id) {
      db.collection('products').doc(id).get()
      .then(doc => { 
          //console.log(doc.data().title);
          let procutsSingle = doc.data();
          procutsSingle.id = doc.id
          procutsSingle.rating = doc.data().rating
          procutsSingle.name = doc.data().name
          procutsSingle.description = doc.data().description
          procutsSingle.image = doc.data().image
          procutsSingle.avalible = doc.data().avalible
          procutsSingle.price = doc.data().price
          commit('nuevosProducts', procutsSingle)
        })
    }
  }
})
